import * as React from 'react'
import '../styles/App.scss'
import {FlatButton} from 'material-ui'
import {AppBarContainer} from './CustomAppBar'
import PageTitle from '../components/PageTitle'
import {ROUTES} from '../constants/routes'
import {Api} from '../services/api/api'
import {StoreState} from '../reducers'
import {RouterAction, routerActions} from 'react-router-redux'
import {connect, Dispatch} from 'react-redux'
import {ClientInfo} from '../types'
import {Actions as SignInActions} from '../actions/signIn'
import {ActionType as UserActionType} from '../actions/user'
import {LoadingSpinner} from '../components/LoadingSpinner'
import 'react-perfect-scrollbar/dist/css/styles.css'
import '../styles/ContactUs.scss'
import {StringResources} from '../localization/StringResources'
import {Strings} from '../localization'
import {BaseContainer} from './BaseContainer'
import {EventType} from '../services/events/events'

import {Sticky, StickyContainer} from 'react-sticky'

import {Actions as ErrorActions, ActionType as ErrorInfoActionType} from '../actions/errorInfo'
import {Error as ErrorInfo} from '../types/Errors/Error'
import Mapper from '../utils/Mapper'
import {RESCHEDULE} from '../constants/reschedule'
import {reschedule} from '../actions/setJobDetails'
import {RouteComponentProps} from 'react-router';
import {ContactUsParams, ContactUsType} from '../types/ContactUs';

interface ContactUsProps {
  routePush: (location: string) => RouterAction
  onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
  reschedule: (isRescheduling: boolean) => void
  client: ClientInfo
  isRescheduling: boolean
}

interface ContactUsStates {
  btnBlocked: boolean
  issue: string
  requestSent: boolean
  sending: boolean
}

type Props = ContactUsProps & RouteComponentProps<any>;

class ContactUs extends React.Component<Props, ContactUsStates> {
  constructor(props) {
    super(props)
    this.state = {
      btnBlocked: true,
      issue: '',
      requestSent: false,
      sending: false
    }
  }

  sendIssueMessage = (message:string, issueInfo: ContactUsParams) => {
    Api.sendIssue(message, issueInfo)
        .then(() => {
          this.setState({ sending: false, requestSent: true });
        })
        .catch(error => {
          console.log("sendIssueError", error);
          this.setState({ sending: false });
          this.props.onErrorEvent(Mapper.mapError(error));
        });
  }

  sendIssue = (e) => {
    e.preventDefault();
    this.setState({ sending: true });
    if (this.state.issue.length > 0) {
      const message = this.state.issue;

      this.sendIssueMessage(message, this.props.location.state as ContactUsParams );
    }
  }

  onChange = (e) => {
    this.setState({
      issue: e.target.value
    })
  }

  onCancelClick = () => {
    let route = this.props.isRescheduling ? ROUTES.BID_ACCEPTED : ROUTES.PICKUP_LOCATION
    this.props.reschedule(false)
    this.props.routePush(route)
  }

  render() {
    return (
      <BaseContainer pageName={EventType.CONTACT_US} classname="contactUsContainer">
        <AppBarContainer
          isIconButtonsShown={true}
          isMenuShown={true}
        />
        <PageTitle text={StringResources.getString(Strings.ContactUs.Title)} />
        <LoadingSpinner show={this.state.sending} />
        {
          !this.state.requestSent ?
            <span>
              <p className="centeredText">{StringResources.getString(Strings.ContactUs.Paragraphs.DescribeIssue)}</p>
              <form onSubmit={this.sendIssue}>
                <textarea
                  className="issueArea"
                  onChange={this.onChange}
                  defaultValue={this.props.isRescheduling ? RESCHEDULE : ''}
                />
              </form>
            </span>
            :
            <span>
              <h3>{StringResources.getString(Strings.ContactUs.Headers.RequestSent)}</h3>
              <p>{StringResources.getString(Strings.ContactUs.Paragraphs.WeWillReviewMsg)}</p>
              <p>{StringResources.getString(Strings.ContactUs.Paragraphs.YouWillBeContacted)}</p>
              <p className="linkColor">{this.props.client.email}</p>
            </span>
        }
        <StickyContainer className="sticky-footer sb" >
          <Sticky>
            {() => (
              <div className="bottom-part hover">
                {
                  !this.state.requestSent ?
                    <div>
                      <FlatButton
                        label="Cancel"
                        className="flatbutton next"
                        onClick={this.onCancelClick}
                      />
                      <FlatButton
                        label="Send"
                        className={this.state.issue === '' ? 'flatbutton disabled next' : 'flatbutton next'}
                        onClick={this.sendIssue}
                        disabled={this.state.issue === ''}
                      />
                    </div>
                    :
                    <FlatButton
                      label="Close"
                      className="flatbutton next"
                      onClick={this.onCancelClick}
                    />
                }
              </div>
            )}
          </Sticky>
        </StickyContainer>
      </BaseContainer>
    )
  }
}

function mapStateToProps(state: StoreState) {
  return {
    client: state.auth.user,
    isRescheduling: state.jobDetails.isRescheduling
  }
}

function mapDispatchToProps(dispatch: Dispatch<RouterAction | UserActionType | ErrorInfoActionType>) {
  return {
    routePush: (location: string) => dispatch(routerActions.push(location)),
    updateUser: (client: ClientInfo) => dispatch(SignInActions.authorize(client)),
    onErrorEvent: (errorInfo: ErrorInfo) => dispatch(ErrorActions.newError(errorInfo)),
    reschedule: (isRescheduling: boolean) => dispatch(reschedule(isRescheduling))
  }
}

export const ContactUsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactUs)



// WEBPACK FOOTER //
// ./src/containers/ContactUs.tsx